import { queryOptions } from '@tanstack/react-query';

import type { GetStudioItemParams } from './get-studio-item';
import { getStudioItem } from './get-studio-item';
import {
  retrieveStudioItemFeedbacks,
  type RetrieveStudioItemFeedbacksParams,
} from './retrieve-studio-item-feedbacks';

export const studioQueryKeys = {
  all: ['studio'] as const,
  details: () => [...studioQueryKeys.all, 'detail'] as const,
  detail: (params: GetStudioItemParams) =>
    [...studioQueryKeys.details(), params] as const,
  itemFeedbacks: (itemId: Alias, params: RetrieveStudioItemFeedbacksParams) =>
    [...studioQueryKeys.all, 'item-feedbacks', itemId, params] as const,
};

export const studioItemQueryOptions = (
  params: GetStudioItemParams,
  options?: { enabled?: boolean },
) =>
  queryOptions({
    queryKey: studioQueryKeys.detail(params),
    queryFn: () => getStudioItem(params),
    enabled: Boolean(params.item_id),
    ...options,
  });

export const studioItemFeedbacksQueryOptions = (
  itemId: Alias,
  params: RetrieveStudioItemFeedbacksParams,
) =>
  queryOptions({
    queryKey: studioQueryKeys.itemFeedbacks(itemId, params),
    queryFn: () => retrieveStudioItemFeedbacks(itemId, params),
    select: (response) => response.items ?? [],
  });
